export const FormCypressAttribute = {
  buttons: {
    FLOW_BACK: 'FormCypressAttribute:buttons:FLOW_BACK',
    FLOW_NEXT: 'FormCypressAttribute:buttons:FLOW_NEXT',
    FLOW_NEXT_AND_DONE: 'FormCypressAttribute:buttons:FLOW_NEXT_AND_DONE',
    ADD_ENTITY: 'FormCypressAttribute:buttons:ADD_ENTITY',
    LOAD_MORE: 'FormCypressAttribute:buttons:LOAD_MORE',
    MODAL_CANCEL: 'FormCypressAttribute:buttons:MODAL_CANCEL',
    MODAL_CLOSE: 'FormCypressAttribute:buttons:MODAL_CLOSE',
    DELETE_FILE: 'FormCypressAttribute:buttons:DELETE_FILE',
    APPLY: 'FormCypressAttribute:buttons:APPLY',
    SELECT_FILE: 'FormCypressAttribute:buttons:SELECT_FILE',
    ADD_DOCUMENT: 'FormCypressAttribute:buttons:ADD_DOCUMENT',
    ACTION_BUTTON: 'FormCypressAttribute:buttons:ACTION_BUTTON',
    TOGGLE_BUTTON: 'FormCypressAttribute:buttons:TOGGLE_BUTTON',
    TOGGLE_BUTTON_ICON: 'FormCypressAttribute:buttons:TOGGLE_BUTTON_ICON',
    TOGGLE_BUTTON_ICON_ICON: 'FormCypressAttribute:buttons:TOGGLE_BUTTON_ICON_ICON',
    FORM_SELECT_ADD_OPTION_ROW: 'form/buttons/FORM_SELECT_ADD_OPTION_ROW'
  },
  inputs: {
    AMOUNT: 'FormCypressAttribute:AMOUNT',
    FILE_UPLOAD: 'FormCypressAttribute:FILE_UPLOAD',
    FILE_UPLOAD_NAME: 'FormCypressAttribute:FILE_UPLOAD_NAME',
    TOGGLE_GROUP: 'FormCypressAttribute:TOGGLE_GROUP',
    TOGGLE: 'FormCypressAttribute:TOGGLE',
    PRECISION: 'FormCypressAttribute:PRECISION',
    MARKDOWN: 'FormCypressAttribute:MARKDOWN',
    MESSAGE_INPUT: 'FormCypressAttribute:inputs:MESSAGE_INPUT',
    PHONE_NUMBER: 'FormCypressAttribute:PHONE_NUMBER',
    LABEL: 'FormCypressAttribute:LABEL'
  },
  texts: {
    PRESS_ENTER_TEXT: 'FormCypressAttribute:buttons:PRESS_ENTER_TEXT'
  },
  views: {
    HEADER_ID: 'FormCypressAttribute:HEADER_ID',
    BOX_CHECKBOX_GROUP_WRAPPER: 'FormCypressAttribute:views:BOX_CHECKBOX_GROUP_WRAPPER',
    BOX_CHECKBOX_GROUP_LIST: 'FormCypressAttribute:BOX_CHECKBOX_GROUP_LIST',
    CHECKBOX: 'FormCypressAttribute:CHECKBOX',
    BOX_CHECKBOX: 'FormCypressAttribute:views:BOX_CHECKBOX',
    CHECKBOX_FIELD: 'FormCypressAttribute:CHECKBOX_FIELD',
    flowFlowingLoader: 'FormCypressAttribute:flowFlowingLoader',
    MODAL: 'FormCypressAttribute:MODAL',
    GALLERY: 'FormCypressAttribute:GALLERY',
    GALLERY_DOCUMENT: 'FormCypressAttribute:GALLERY_DOCUMENT',
    FORM_UPLOAD_OR_SELECT_MULTIPLE: 'FormCypressAttribute:FORM_UPLOAD_OR_SELECT_MULTIPLE',
    FORM_UPLOAD_OR_SELECT: 'FormCypressAttribute:FORM_UPLOAD_OR_SELECT',
    DOCUMENT_ELEMENT: 'FormCypressAttribute:DOCUMENT_ELEMENT',
    FORM_MULTISELECT_OPTION: 'FormCypressAttribute:views:FORM_MULTISELECT_OPTION',
    VERTICAL_PROGRESS_STEP: 'FormCypressAttribute:views:VERTICAL_STEP_PROGESS',
    LABEL: 'FormCypressAttribute:views:LABEL',
    OR_LABEL: 'FormCypressAttribute:views:OR_LABEL',
    SELECT_FILE_ICON: 'FormCypressAttribute:views:SELECT_FILE_ICON',
    FORM_SELECT_STATE_MESSAGE: 'form/views/FORM_SELECT_STATE_MESSAGE',
    FORM_SELECT_ADD_OPTION_ROW_ICON: 'form/views/FORM_SELECT_ADD_OPTION_ROW_ICON',
    FORM_SELECT_PINNED_ADD_OPTION: 'form/views/FORM_SELECT_PINNED_ADD_OPTION'
  },
  fullNameContactForm: {
    inputs: {
      TITLE: 'FormCypressAttribute:TITLE',
      FIRST_NAME: 'FormCypressAttribute:FIRST_NAME',
      MIDDLE_NAME: 'FormCypressAttribute:MIDDLE_NAME',
      LAST_NAME: 'FormCypressAttribute:LAST_NAME',
      LAST_NAME_AT_BIRTH: 'FormCypressAttribute:LAST_NAME_AT_BIRTH',
      DATE_OF_BIRTH: 'FormCypressAttribute:DATE_OF_BIRTH'
    }
  },
  predeceasedChildContactForm: {
    inputs: {
      PLACE_OF_DEATH: 'FormCypressAttribute:PLACE_OF_DEATH'
    }
  },
  guardianFullNameContactForm: {
    inputs: {
      FIRST_NAME: 'FormCypressAttribute:guardianFullNameContactForm:inputs:FIRST_NAME',
      MIDDLE_NAME: 'FormCypressAttribute:guardianFullNameContactForm:inputs:MIDDLE_NAME',
      LAST_NAME: 'FormCypressAttribute:guardianFullNameContactForm:inputs:LAST_NAME'
    }
  },
  fullNameSocialContactForm: {
    inputs: {
      SOCIAL_INSURANCE_NUMBER: 'FormCypressAttribute:SOCIAL_INSURANCE_NUMBER'
    }
  },
  formerSpouseMarriageContactForm: {
    inputs: {
      COUNTRY: 'FormCypressAttribute:COUNTRY',
      AREA: 'FormCypressAttribute:AREA',
      JURISDICTION: 'FormCypressAttribute:JURISDICTION',
      FIRST_NAME: 'FormCypressAttribute:FIRST_NAME',
      START_DATE: 'FormCypressAttribute:START_DATE',
      END_DATE: 'FormCypressAttribute:END_DATE',
      LAST_NAME: 'FormCypressAttribute:LAST_NAME',
      TERMINATION_REASON: 'FormCypressAttribute:TERMINATION_REASON',
      SPOUSE_DEATH_DATE: 'FormCypressAttribute:SPOUSE_DEATH_DATE',
      DIVORCE_JUDGEMENT_NUMBER: 'FormCypressAttribute:DIVORCE_JUDGEMENT_NUMBER',
      COURT_DISTRICT: 'FormCypressAttribute:COURT_DISTRICT'
    }
  },
  employmentContactForm: {
    inputs: {
      IS_EMPLOYED_OR_RETIRED: 'FormCypressAttribute:IS_EMPLOYED_OR_RETIRED',
      JOB_TITLE: 'FormCypressAttribute:JOB_TITLE',
      EMPLOYER: 'FormCypressAttribute:EMPLOYER',
      SERVICE_BRANCH: 'FormCypressAttribute:SERVICE_BRANCH',
      START_DATE: 'FormCypressAttribute:START_DATE',
      END_DATE: 'FormCypressAttribute:END_DATE',
      ARMY_ID: 'FormCypressAttribute:ARMY_ID',
      EMPLOYMENT_STATUS: 'FormCypressAttribute:EMPLOYMENT_STATUS',
      EMPLOYMENT_DETAILS: 'FormCypressAttribute:EMPLOYMENT_DETAILS'
    },
    texts: {
      STATUS_LABEL: 'FormCypressAttribute:texts:STATUS_LABEL',
      DETAILS_LABEL: 'FormCypressAttribute:texts:DETAILS_LABEL'
    }
  },
  nextOfKinForm: {
    buttons: {
      SAVE: 'FormCypressAttribute:nextOfKinForm:buttons:SAVE'
    },
    inputs: {
      FIRST_NAME: 'FormCypressAttribute:nextOfKinForm:inputs:FIRST_NAME',
      MIDDLE_NAME: 'FormCypressAttribute:nextOfKinForm:inputs:MIDDLE_NAME',
      LAST_NAME: 'FormCypressAttribute:nextOfKinForm:inputs:LAST_NAME',
      RELATIONSHIP_TYPE: 'FormCypressAttribute:nextOfKinForm:inputs:RELATIONSHIP_TYPE',
      LEGAL_SEX: 'FormCypressAttribute:nextOfKinForm:inputs:LEGAL_SEX',
      IS_DECEASED: 'FormCypressAttribute:nextOfKinForm:inputs:IS_DECEASED',
      HAD_CHILDREN: 'FormCypressAttribute:nextOfKinForm:inputs:HAD_CHILDREN',
      GUARDIAN_USER_SELECT: 'FormCypressAttribute:nextOfKinForm:inputs:GUARDIAN_USER_SELECT',
      NOK_USER_SELECT: 'FormCypressAttribute:nextOfKinForm:inputs:NOK_USER_SELECT'
    }
  },
  personalRepresentativeForm: {
    buttons: {
      SAVE: 'FormCypressAttribute:personalRepresentativeForm:buttons:SAVE'
    },
    inputs: {
      LEGAL_SEX: 'FormCypressAttribute:personalRepresentativeForm:inputs:LEGAL_SEX',
      USER_SELECT: 'FormCypressAttribute:personalRepresentativeForm:inputs:USER_SELECT',
      CONTACT_HAS_ALIAS: 'FormCypressAttribute:personalRepresentativeForm:inputs:CONTACT_HAS_ALIAS',
      HAS_NO_DRIVERS_LICENSE:
        'FormCypressAttribute:personalRepresentativeForm:inputs:HAS_NO_DRIVERS_LICENSE',
      DRIVERS_LICENSE_UPLOAD:
        'FormCypressAttribute:personalRepresentativeForm:inputs:DRIVERS_LICENSE_UPLOAD',
      LAST_THREE_DIGITS: 'FormCypressAttribute:personalRepresentativeForm:inputs:LAST_THREE_DIGITS',
      LAST_THREE_DIGITS_SSN:
        'FormCypressAttribute:personalRepresentativeForm:inputs:LAST_THREE_DIGITS_SSN',
      ID_UPLOAD: 'FormCypressAttribute:personalRepresentativeForm:inputs:ID_UPLOAD',
      IS_RETIRED: 'FormCypressAttribute:personalRepresentativeForm:inputs:IS_RETIRED',
      JOB_TITLE: 'FormCypressAttribute:personalRepresentativeForm:inputs:JOB_TITLE',
      DRIVERS_LICENSE_NUMBER:
        'FormCypressAttribute:personalRepresentativeForm:inputs:DRIVERS_LICENSE_NUMBER',
      HAS_NO_PASSPORT: 'FormCypressAttribute:personalRepresentativeForm:inputs:HAS_NO_PASSPORT',
      PASSPORT_UPLOAD: 'FormCypressAttribute:personalRepresentativeForm:inputs:PASSPORT_UPLOAD',
      PASSPORT_NUMBER: 'FormCypressAttribute:personalRepresentativeForm:inputs:PASSPORT_NUMBER',
      PRIMARY_ID_UPLOAD: 'FormCypressAttribute:personalRepresentativeForm:inputs:PRIMARY_ID_UPLOAD',
      SECONDARY_ID_UPLOAD:
        'FormCypressAttribute:personalRepresentativeForm:inputs:SECONDARY_ID_UPLOAD'
    },
    views: {
      PASSPORT_SECTION: 'FormCypressAttribute:personalRepresentativeForm:views:PASSPORT_SECTION',
      DRIVERS_LICENSE_SECTION:
        'FormCypressAttribute:personalRepresentativeForm:views:DRIVERS_LICENSE_SECTION',
      EMPLOYMENT_SECTION:
        'FormCypressAttribute:personalRepresentativeForm:views:EMPLOYMENT_SECTION',
      REMAINING_FORM_INPUTS:
        'FormCypressAttribute:personalRepresentativeForm:views:REMAINING_FORM_INPUTS',
      VALID_IDENTIFICATION_SECTION:
        'FormCypressAttribute:personalRepresentativeForm:views:VALID_IDENTIFICATION_SECTION',
      PRIMARY_ID_UPLOAD_SECTION:
        'FormCypressAttribute:personalRepresentativeForm:views:PRIMARY_IDENTIFICATION_UPLOAD_SECTION',
      CALIFORNIA_REP_FORM_SECTION:
        'FormCypressAttribute:personalRepresentativeForm:views:CALIFORNIA_REP_FORM_SECTION'
    }
  },
  formerSpouseUserForm: {
    inputs: {
      FIRST_NAME: 'FormCypressAttribute:FIRST_NAME',
      MIDDLE_NAME: 'FormCypressAttribute:MIDDLE_NAME',
      LAST_NAME: 'FormCypressAttribute:LAST_NAME'
    }
  },
  successorUserForm: {
    buttons: {
      ADD_PARENT: 'FormCypressAttribute:buttons:ADD_PARENT',
      ADD_SIBLING: 'FormCypressAttribute:buttons:ADD_PARENT',
      ADD_NIECE_OR_NEPHEW: 'FormCypressAttribute:buttons:ADD_NIECE_OR_NEPHEW'
    }
  },
  birthContactForm: {
    texts: {
      TITLE: 'FormCypressAttribute:TITLE'
    },
    inputs: {
      BIRTH_CITY: 'FormCypressAttribute:BIRTH_CITY',
      BIRTH_JURISDICTION: 'FormCypressAttribute:BIRTH_JURISDICTION',
      BIRTH_AREA: 'FormCypressAttribute:BIRTH_AREA',
      BIRTH_COUNTY: 'FormCypressAttribute:BIRTH_COUNTY',
      BIRTH_AREA_SELECT: 'FormCypressAttribute:BIRTH_AREA_SELECT',
      BIRTH_COUNTRY: 'FormCypressAttribute:BIRTH_COUNTRY'
    }
  },
  contactCitizenshipForm: {
    inputs: {
      CITIZENSHIP_COUNTRY: 'FormCypressAttribute:CITIZENSHIP_COUNTRY'
    },
    texts: {
      CONTACT_CITIZENSHIP_LABEL:
        'FormCypressAttribute:contactCitizenshipForm:texts:CONTACT_CITIZENSHIP_LABEL'
    }
  },
  contactPermanentResidentForm: {
    inputs: {
      IS_PERMANENT_RESIDENT: 'FormCypressAttribute:inputs:IS_PERMANENT_RESIDENT',
      IS_PERMANENT_RESIDENT_DETAILS: 'FormCypressAttribute:inputs::IS_PERMANENT_RESIDENT_DETAILS'
    },
    views: {
      PERMANENT_RESIDENT: 'FormCypressAttribute:views:IS_PERMANENT_RESIDENT,'
    }
  },
  shortNameContactForm: {
    inputs: {
      FIRST_NAME: 'FormCypressAttribute:shortNameContactForm:inputs:FIRST_NAME',
      LAST_NAME: 'FormCypressAttribute:shortNameContactForm:inputs:LAST_NAME',
      MIDDLE_NAME: 'FormCypressAttribute:shortNameContactForm:inputs:MIDDLE_NAME'
    }
  },
  appointUserForm: {
    views: {
      APPOINT_USER: 'FormCypressAttribute:appointUserForm:views:APPOINT_USER',
      REMOVE_USER: 'FormCypressAttribute:appointUserForm:views:REMOVE_USER'
    }
  },
  legalGuardianContactForm: {
    inputs: {
      EXISTING_GUARDIAN: 'FormCypressAttribute:legalGuardianContactForm:inputs:EXISTING_GUARDIAN'
    },
    views: {
      FORM: 'FormCypressAttribute:legalGuardianContactForm:views:FORM'
    }
  },
  relationshipSelectForm: {
    inputs: {
      RELATIONSHIP_TO_DECEASED:
        'FormCypressAttribute:relationshipSelectForm:inputs:RELATIONSHIP_TO_DECEASED',
      RELATIONSHIP_TO_DECEASED_SPECIFY_INPUT:
        'FormCypressAttribute:relationshipSelectForm:inputs:RELATIONSHIP_TO_DECEASED_SPECIFY_INPUT',
      RELATIONSHIP_TO_ESTATE:
        'FormCypressAttribute:relationshipSelectForm:inputs:RELATIONSHIP_TO_ESTATE'
    }
  },
  contactAliasForm: {
    inputs: {
      FIRST_NAME: 'FormCypressAttribute:contactAliasForm:inputs:FIRST_NAME',
      MIDDLE_NAME: 'FormCypressAttribute:contactAliasForm:inputs:MIDDLE_NAME',
      LAST_NAME: 'FormCypressAttribute:contactAliasForm:inputs:FULL_NAME'
    },
    buttons: {
      ADD_CONTACT_ALIAS: 'FormCypressAttribute:contactAliasForm:buttons:ADD_CONTACT_ALIAS',
      DELETE_ALIAS: 'FormCypressAttribute:contactAliasForm:buttons:DELETE_ALIAS'
    }
  },
  contactOtherNamesForm: {
    inputs: {
      OTHER_NAME: 'FormCypressAttribute:contactOtherNamesForm:inputs:OTHER_NAME'
    },
    buttons: {
      ADD_OTHER_NAME: 'FormCypressAttribute:contactOtherNamesForm:buttons:ADD_OTHER_NAME',
      DELETE_OTHER_NAME: 'FormCypressAttribute:contactOtherNamesForm:buttons:DELETE_OTHER_NAME'
    }
  },
  flowSummary: {
    buttons: {
      EDIT_FLOW_SUMMARY: 'FormCypressAttribute.flowSummary.buttons.EDIT_FLOW_DETAIL_CARD'
    },
    views: {
      FLOW_SUMMARY_CARD: 'FormCypressAttribute.flowSummary.views.FLOW_SUMMARY_CARD'
    }
  },
  selectPopover: {
    buttons: {
      LOAD_MORE: 'FormCypressAttribute:selectPopover:buttons:LOAD_MORE'
    },
    inputs: {
      SEARCH: 'FormCypressAttribute:selectPopover:inputs:SEARCH'
    },
    views: {
      ITEM: 'FormCypressAttribute:selectPopover:views:ITEM',
      ITEMS: 'FormCypressAttribute:selectPopover:views:ITEMS',
      GROUP: 'FormCypressAttribute:selectPopover:views:GROUP'
    }
  },
  enumSelectPopover: {
    views: {
      TRIGGER: 'FormCypressAttribute:enumSelectPopover:views:TRIGGER',
      TRIGGER_LOADING: 'FormCypressAttribute:enumSelectPopover:views:TRIGGER_LOADING'
    }
  },
  userSelectPopover: {
    views: {
      TRIGGER: 'FormCypressAttribute:userSelectPopover:views:TRIGGER'
    }
  },
  tooltip: {
    buttons: {
      TRIGGER: 'FormCypressAttribute:tooltip:views:TRIGGER',
      CANCEL: 'FormCypressAttribute:tooltip:buttons:CANCEL',
      SAVE: 'FormCypressAttribute:tooltip:buttons:SAVE',
      DELETE: 'FormCypressAttribute:tooltip:buttons:DELETE',
      EDIT: 'FormCypressAttribute:tooltip:buttons:EDIT'
    },
    views: {
      CONTENT: 'FormCypressAttribute:tooltip:views:CONTENT'
    },
    inputs: {
      TEXT: 'FormCypressAttribute:tooltip:inputs:TEXT'
    }
  }
};
